import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l('<path fill="#000" d="M1.985 11.304A19.921 19.921 0 0 0 0 20c0 3.116.713 6.066 1.985 8.696L20 30.435l18.015-1.74A19.921 19.921 0 0 0 40 20c0-3.116-.713-6.066-1.985-8.696L20 9.565l-18.015 1.74Z"></path><path fill="#496E2D" d="M1.985 28.696C5.219 35.386 12.07 40 20 40s14.78-4.614 18.015-11.304H1.985Z"></path><path fill="#D80027" d="M1.985 11.304h36.03C34.781 4.614 27.93 0 20 0S5.22 4.615 1.985 11.304Z"></path><path fill="#F0F0F0" d="m24.655 16.343 1.64 2.261 2.658-.862-1.643 2.26 1.64 2.26-2.656-.864-1.643 2.26.001-2.795-2.656-.865 2.657-.861.002-2.794Z"></path><path fill="#F0F0F0" d="M20.177 25.652a5.652 5.652 0 1 1 2.688-10.625 6.956 6.956 0 1 0 0 9.945c-.8.434-1.715.68-2.688.68Z"></path>', 5), c = [
  o
];
function h(i, n) {
  return t(), e("svg", a, [...c]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
